import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AuthTheme.css";
import API_BASE_URL from "../config";
import { BsShieldLockFill, BsArrowLeft, BsCheckCircleFill, BsXCircleFill } from "react-icons/bs";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/forgot-password`, { email });
      setMessage(res.data.message);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pf-auth pf-auth--center">
      <div className="pf-shell">
        <div className="pf-card">
          <div className="pf-card-icon"><BsShieldLockFill /></div>
          <div>
            <h1 className="pf-title">Reset your password</h1>
            <p className="pf-sub">Enter your email and we'll send you a reset link.</p>
          </div>

          <form className="pf-form" onSubmit={handleSubmit}>
            <div className="pf-field">
              <label htmlFor="fp-email">Email</label>
              <input id="fp-email" className="pf-input" type="email" placeholder="you@company.com"
                value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <button type="submit" className="pf-btn" disabled={loading}>
              {loading ? "Sending..." : "Send reset link"}
            </button>
          </form>

          {message && <div className="pf-msg pf-msg--ok"><BsCheckCircleFill /> {message}</div>}
          {error && <div className="pf-msg pf-msg--err"><BsXCircleFill /> {error}</div>}

          <button className="pf-link" style={{ display: "inline-flex", alignItems: "center", gap: "6px", alignSelf: "center" }}
            onClick={() => navigate("/login")}>
            <BsArrowLeft /> Back to sign in
          </button>
        </div>
      </div>
    </div>
  );
}
